.root {
  min-height: 100vh;
  padding: env(safe-area-inset-top, 0) env(safe-area-inset-right, 0)
    env(safe-area-inset-bottom, 0) env(safe-area-inset-left, 0);
  background: var(
    --survey-page-bg,
    linear-gradient(
      180deg,
      var(--mantine-color-gray-0) 0%,
      var(--mantine-color-plum-0) 100%
    )
  );
}

.inner {
  max-width: 28rem;
  margin: 0 auto;
  padding: var(--mantine-spacing-xl) var(--mantine-spacing-md);
}
